import {DeleteOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {FormListFieldData} from 'antd/es/form/FormList';
import React, {FC} from 'react';

import {EComparisonType} from 'components/form/hooks/use-form-watcher/use-form-watcher-constants';

import {lengthValidationRule, numberWithDotRule, requiredInputRule} from '../../utils';

interface IProductionIndicatorsItemProps {
    field: FormListFieldData;
    onRemove: (index: number) => void;
}

export const ProductionIndicatorsItem: FC<IProductionIndicatorsItemProps> = ({field, onRemove}: IProductionIndicatorsItemProps) => (
        <div className="project-item-block">
            <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => onRemove(field.name)}
                className="delete-button"
            />
            <div className="form-flex-row">
                <Form.Item
                    {...field}
                    name={[field.name, 'productName']}
                    label="Наименование продукции"
                    rules={[requiredInputRule()]}
                >
                    <Input placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    {...field}
                    name={[field.name, 'productCode']}
                    label='Код продукции по "ОКПД2" (ОК 034-2014)'
                    rules={[
                        lengthValidationRule({comparisonOperator: EComparisonType.GREATER, value: 2}),
                        lengthValidationRule({comparisonOperator: EComparisonType.LESS, value: 12}),
                    ]}
                >
                    <Input placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
            </div>

            <div className="form-flex-row">
                <Form.Item
                    {...field}
                    name={[field.name, 'quantityUnit']}
                    label='Единица измерения (ОКЕИ - ОК 015-94 (МК 002-97))"'
                    rules={[
                        lengthValidationRule({comparisonOperator: EComparisonType.GREATER, value: 3}),
                        lengthValidationRule({comparisonOperator: EComparisonType.LESS, value: 4}),
                    ]}
                >
                    <Input placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    {...field}
                    name={[field.name, 'productionYearCapacity']}
                    label="Годовая плановая производственная мощность: количество"
                    rules={[
                        numberWithDotRule({valueBefore: 17, valueAfter: 2}),
                    ]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    {...field}
                    name={[field.name, 'productionYearAmount']}
                    label="Годовая плановая производственная мощность: руб."
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off" />
                </Form.Item>
            </div>
        </div>
    );


